import React from 'react'
import styled from 'styled-components'
import Modal from '@jarvis.oddle/core/components/Modal'
import { makeControlledModal } from 'src/decorators/ModalController'
import { paddingSizes } from '@jarvis.oddle/core/theme/default'
import breakpoint from '@jarvis.oddle/core/tools/styled-components-breakpoint'
import IconClose from '@jarvis.oddle/core/components/Icons/IconClose'
import Flex from '@jarvis.oddle/core/components/Flex'
import { ADDTHIS_PUBLIC_ID } from 'config/client'
import SocialMediaSharing from './SocialMediaSharing'


const Container = styled(Modal.FlexContainer).attrs(() => ({
  width: '100%',
  height: '100%',
  flexDirection: 'column',
  padding: paddingSizes.medium
}))`
  position: relative;
  background: ${(props) => props.theme.colorContainerColor};
  width: 95%;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  transform: translateX(-50%) translateY(-50%);
  top: 50%;
  left: 50%;
  height: fit-content;
  ${breakpoint('desktop')`
    width: 100%;
    max-width: 600px;
    height: fit-content;
  `}
`

const CloseButtonContainer = styled(Flex).attrs(() => ({
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  role: 'button'
}))`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  z-index: 10;
`

interface ShareAppModalProps {
  modal: {
    show: boolean
    onClose: (x: () => void) => void
  }
  publicUrl: string
  storeOrder: Oms.V4.StoreOrder
}

const ShareAppModal = ({
  modal,
  publicUrl,
  storeOrder
}: ShareAppModalProps): JSX.Element => {
  return (
    <Modal {...modal} show={modal.show} slideInAnimation='right'>
      <Container>
        <CloseButtonContainer onClick={modal.onClose}>
          <IconClose fill='currentColor' width={14} height={14} />
        </CloseButtonContainer>
        <SocialMediaSharing
          text='Share'
          widgetId={ADDTHIS_PUBLIC_ID}
          publicUrl={publicUrl}
          storeOrder={storeOrder}
        />
      </Container>
    </Modal>
  )
}

export default makeControlledModal(ShareAppModal, 'ShareAppModal')
